import { render } from "./NewHome.vue?vue&type=template&id=ea617c06"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"

import "./NewHome.vue?vue&type=style&index=0&id=ea617c06&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__